import { AnimatePresence, useSpring } from "motion/react";
import { motion } from "motion/react";
import { defaultSectionTransition } from "../transitions";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext, CarColors, ConcertTypes, ProfileContext } from "../contexts/AppContext";
import { calculateScore, persistScore } from "../services/scoringService";

import "./screens.scss";
import "./concert.scss";

export default function Concert() {
  const { setProfile, firstName, lastName, carColor, concertType } = useContext(ProfileContext);
  if (!setProfile) return null;

  const { setData } = useContext(AppContext);
  if (!setData) return null;

  const navigate = useNavigate();

  const enum View {
    CONGRATS,
    SCORE,
  }

  const [activeView, setActiveView] = useState(View.CONGRATS);

  const [score, setScore] = useState("0");
  const animatedScore = useSpring(0, { bounce: 0, duration: 2000 });
  animatedScore.on("change", (value) => {
    const formatted = value.toFixed(0).toLocaleString();
    setScore(formatted);
  });
  animatedScore.set(calculateScore());

  return (
    <section className="screen screen--concert" style={{ backgroundImage: `url(bg-concert-b.jpg)` }}>
      <div className="car" style={{ backgroundImage: `url("car-day-${carColor?.toLowerCase()}.png")` }} />
      <div className="balloons">
        <AnimatePresence>
          <motion.img
            key="balloon-1"
            className="balloon balloon--1"
            src="balloon-1.png"
            animate={{
              y: [0, -8, 0],
              x: [0, 10, 0],
            }}
            transition={{
              x: { duration: 10, repeat: Infinity, ease: "easeInOut" },
              y: { duration: 8, repeat: Infinity, ease: "easeInOut" },
            }}
          />
          <motion.img
            key="balloon-2"
            className="balloon balloon--2"
            src="balloon-2.png"
            animate={{
              y: [0, 10, 0],
              x: [0, -6, 0],
            }}
            transition={{
              x: { duration: 5, repeat: Infinity, ease: "easeInOut" },
              y: { duration: 6, repeat: Infinity, ease: "easeInOut" },
            }}
          />
          <motion.img
            key="balloon-3"
            className="balloon balloon--3"
            src="balloon-3.png"
            animate={{
              y: [0, 8, 0],
              x: [8, 0, 8],
            }}
            transition={{
              x: { duration: 6, repeat: Infinity, ease: "easeInOut" },
              y: { duration: 7, repeat: Infinity, ease: "easeInOut" },
            }}
          />
          <motion.img
            key="balloon-4"
            className="balloon balloon--4"
            src="balloon-4.png"
            animate={{
              y: [0, -20, 0],
              x: [0, 15, 0],
            }}
            transition={{
              x: { duration: 12, repeat: Infinity, ease: "easeInOut" },
              y: { duration: 15, repeat: Infinity, ease: "easeInOut" },
            }}
          />
           <motion.img
            key="balloon-5"
            className="balloon balloon--5"
            src="balloon-3.png"
            animate={{
              y: [0, 8, 0],
              x: [0, 8, 0],
            }}
            transition={{
              x: { duration: 5, repeat: Infinity, ease: "easeInOut" },
              y: { duration: 4, repeat: Infinity, ease: "easeInOut" },
            }}
          />
        </AnimatePresence>
      </div>
      <AnimatePresence mode={"popLayout"} initial>
        {activeView === View.CONGRATS && (
          <motion.section key="concert--congrats" className="concert__section" {...defaultSectionTransition}>
            <section className="concert__modal">
              <header className="concert__header">
                <img className="concert__image concert__image--0" src={`intro-${concertType?.toLowerCase()}.png`} />
                <h1>Congratulations!</h1>
              </header>
              <section className="concert__body">
                <p>You made it to the festival in your EV. Your family is excited to see their favorite band.</p>
                <p>But first, let's tally up your score!</p>
              </section>
              <button
                className="button button--white"
                onClick={() => {
                  setActiveView(View.SCORE);
                }}
              >
                Next
              </button>
            </section>
          </motion.section>
        )}
        {activeView === View.SCORE && (
          <motion.section key="concert--score" className="concert__section" {...defaultSectionTransition}>
            <section className="concert__modal">
              <header className="concert__header">
                <img className="concert__image concert__image--1" src={`intro-0-${carColor?.toLowerCase()}.png`} />
                <h1>Great Job!</h1>
              </header>
              <section className="concert__body">
                <p>Based on your time, happiness, and battery, you scored</p>
                <p className="concert__score">{score} points!</p>
              </section>
              <button
                className="button button--white"
                onClick={() => {
                  // save the score
                  persistScore({
                    firstName: firstName as string,
                    lastName: lastName as string,
                    carColor: carColor as CarColors,
                    concertType: concertType as ConcertTypes,
                    score: parseInt(score.replace(/,/g, "")),
                  })
                    .then((result) => {
                      // Save the top scores to the context
                      setData({ topScores: result.data.topScores });
                      // save the score to the profile
                      setProfile({ score: animatedScore.get(), key: result.data.score.key });

                      console.log("Score submitted successfully", result);

                      navigate("/leaderboard");
                    })
                    .catch((error) => {
                      console.error("Error submitting score", error);
                    });
                }}
              >
                Next
              </button>
            </section>
          </motion.section>
        )}
      </AnimatePresence>
    </section>
  );
}
